import { map, propEq, propFromSelector } from '../utils';
import { curry, property } from 'lodash-es';
import { compose } from 'redux';
import { jsonApi } from '../http-request';
import {
  CUSTOM_INFORMATION_PREFIX,
  ITEM_DEFINITION_STATES,
  ITEM_DEFINITION_CODES_TO_STATES,
} from '../../constants';

const collection = jsonApi.selectors.collection('item_definitions');
const findResource = jsonApi.findResource(collection);

const findResourceAndHydrate = curry((fn, state) =>
  compose(
    jsonApi.utils.hydrate(state),
    findResource(fn)
  )(state)
);

const createFacade = selector => {
  const propFromResource = propFromSelector(selector);
  const config = propFromResource('config');
  const personBizData = propFromResource('person_biz_data');
  const code = propFromResource('code');
  const uiState = state => {
    const itemDefinitionCode = code(state);
    const isCustomStep = itemDefinitionCode.startsWith(
      CUSTOM_INFORMATION_PREFIX
    );

    return {
      name: isCustomStep
        ? ITEM_DEFINITION_STATES.INFORMATION
        : ITEM_DEFINITION_CODES_TO_STATES[itemDefinitionCode],
      params: isCustomStep
        ? {
            code: itemDefinitionCode
              .split('-')
              .slice(1)
              .join('-'),
          }
        : {},
    };
  };

  return {
    id: propFromResource('id'),
    bannerHtml: propFromResource('banner_html'),
    code,
    completedDescription: propFromSelector(config, 'completed_description'),
    dollar: propFromResource('dollar'),
    icon: propFromResource('icon'),
    kind: propFromResource('kind'),
    longDescription: propFromResource('long_description'),
    order: propFromResource('order'),
    page: propFromResource('page'),
    phaseId: propFromResource('item_definition_phase_id'),
    shortDescription: propFromResource('short_description'),
    time: propFromResource('time'),
    residentPortal: propFromResource('resident_portal'),
    lineOfBusiness: compose(
      property('line_of_business'),
      property('data'),
      personBizData
    ),
    uiState,
  };
};

export const byId = id =>
  createFacade(findResourceAndHydrate(propEq('id', String(id))));

export const byCode = code =>
  createFacade(findResourceAndHydrate(propEq('attributes.code', code)));

export const all = compose(
  map(byId),
  map(property('id')),
  collection
);
